import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_M2M_IN_URL } from "../constants"
import { RootState } from "../../store/store"
import { IErrorResponse } from "../interface"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

async function postM2MInReject(
  token: string | null,
  incomeTransferRequestId: string,
) {
  const response = await axios(
    `${API_M2M_IN_URL}/${incomeTransferRequestId}/reject`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )
  if (checkIsFailure(response.status)) {
    throw new Error(`${response.status}`)
  }
}

export const useRejectIncomingM2M = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<void, IErrorResponse, string, string>({
    mutationFn: (incomeTransferRequestId) =>
      postM2MInReject(token, incomeTransferRequestId),
  })
}
